import script from "./ServiceEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceEditView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceEditView.vue?vue&type=style&index=0&id=08723446&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08723446"]])

export default __exports__